import Cookies from 'js-cookie'

const GOODS_KEY = 'GOODS_KEY'

// export const getGoods = () => Cookies.get(GOODS_KEY)
// export const setGoods = (goods) => Cookies.set(GOODS_KEY, goods)
// export const removGoods = () => Cookies.remove(GOODS_KEY)

const PRODUCT_TYPE_KEY = 'PRODUCT_TYPE_KEY'
export const getProductTypeKey = () => Cookies.get(PRODUCT_TYPE_KEY)
export const setProductTypeKey = () => Cookies.set(PRODUCT_TYPE_KEY, true)
export const removeProductTypeKey = () => Cookies.remove(PRODUCT_TYPE_KEY)

const MARKET_KEY = 'MARKET_KEY'
export const getMarketKey = () => Cookies.get(MARKET_KEY)
export const setMarketKey = () => Cookies.set(MARKET_KEY, true)
export const removeMarketKey = () => Cookies.remove(MARKET_KEY)

const LOGIN_KEY = `${process.env.VUE_APP_LOGIN_ENV}_token`
export const getLoginKey = () => Cookies.get(LOGIN_KEY)

export function removeToken() {
  if (LOGIN_KEY === 'dev_token') {
    Cookies.remove(LOGIN_KEY)
  } else {
    Cookies.remove(LOGIN_KEY, {
      httpOnly: false,
      signed: false,
      domain: '.chinagoods.com',
      path: '/'
    })
  }
}

export function getToken() {
  if (getLoginKey()) {
    return JSON.parse(getLoginKey()).access_token || ''
  }
  return ''
}

export const setStore = (name, content) => {
  if (!name) return
  window.localStorage.setItem(name, content)
}

export const getStore = (name) => {
  if (!name) return
  return window.localStorage.getItem(name)
}

export const removeStore = (name) => {
  if (!name) return
  window.localStorage.removeItem(name)
}

export const getGoods = () => getStore(GOODS_KEY)
export const setGoods = (goods) => setStore(GOODS_KEY, goods)
export const removGoods = () => removeStore(GOODS_KEY)

const BODY_SCROLL_KEY = 'BODY_SCROLL_KEY'
export const getBodyScrollKey = () => Cookies.get(BODY_SCROLL_KEY)
export const setBodyScrollKey = (scroll) => Cookies.set(BODY_SCROLL_KEY, scroll)
export const removeBodyScrollKey = () => Cookies.remove(BODY_SCROLL_KEY)

// 开发环境用于登录写入cookie
export const setCookieForDev = (res) => {
  try {
    if (process.env.VUE_APP_LOGIN_ENV !== 'dev') return false
    Cookies.set('dev_token', JSON.stringify({ access_token: res.access_token, expires_in: res.expires_in }), {
      httpOnly: false,
      signed: false,
      domain: 'localhost',
      expires: 7,
      path: '/'
    })
  } catch (e) {
    console.log(e)
  }
}
